/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon16Light = forwardRef('ArrowShapeTriangleARightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 3.922a1 1 0 0 1 1.545-.839l6.194 4.03a1 1 0 0 1 .008 1.672L5.553 12.9A1 1 0 0 1 4 12.067V3.922Zm7.194 4.03L5 3.922v8.145l6.194-4.115Z" })));
});
